import { useSelector } from 'react-redux';
import { routeParamsSelector } from '../../CommonComponents/Router/Selector';
import { TabSlug } from '../types';

type TabSlugType = typeof TabSlug[keyof typeof TabSlug];

interface RouteParams {
  clientId: string;
  groupId: string;
  accountId: string;
  tabSlug: TabSlugType;
  allocationType: string;
  isApex: string;
}

export const useRouteParams = (): RouteParams => useSelector(routeParamsSelector);
